let JSZip = require("jszip");
require("file-saver");

const state = {
  m_fileList: []
};

const getters = {};

const actions = {
  /* 파일 업로드 */
  uploadFile(context, payload) {
    let uploadList = payload.uploadList;

    let formData = new FormData();
    for (let i = 0; i < uploadList.length; i++) {
      const file = uploadList[i];
      formData.append("file_" + (i + 1), file);
    }
    /* REST-API 구축 시 axios 를 통한 REST-API Call&CallBack 예정 */

    context.commit("uploadFileList", uploadList);
  },
  /* 파일 다운로드 */
  downloadFile(context, file) {
    // let file = payload.fileList[0];

    if (file.isFolder) {
      let zip = new JSZip();
      zip
        .generateAsync({
          type: "blob"
        })
        .then(blob => {
          saveAs(blob, file.name + ".zip");
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      let blob = new Blob([file.content]);
      saveAs(blob, file.name);
    }
  },
  /* 일괄 다운로드(.zip 파일로 압축하여 다운로드) */
  downloadAllFile(context, payload) {
    let fileList = payload.fileList;

    let zip = new JSZip();
    for (let i = 0; i < fileList.length; i++) {
      const item = fileList[i];
      zip.file(item.name, item.content);
    }

    zip
      .generateAsync({
        type: "blob"
      })
      .then(blob => {
        saveAs(blob, "download.zip");
      })
      .catch(err => {
        console.log(err);
      });
  }
};

const mutations = {
  uploadFileList(state, data) {
    for (let i = 0; i < data.length; i++) {
      const file = data[i];
      file.id = 100 + i;
      file.writer = "테스터";
      file.content = file;
      state.m_fileList.push(file);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};



// WEBPACK FOOTER //
// ./src/js/store/modules/files.js